module.exports = __webpack_public_path__ + "static/media/US2000.7d3a9097.svg";